module.exports = __webpack_public_path__ + "static/media/titan_dark.850ddfb5.svg";